import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { toggleSidebar } from "../../store/actions/layout";
const Forbidden = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.auth);
  const { isSidebarOpened } = useSelector((state) => state.layout);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <main
      className="main"
      onClick={() => isSidebarOpened && dispatch(toggleSidebar())}
    >
      <h1 className="main__title">ممنوعات در تمام انواع مرسولات</h1>
      <div className="forbidden">
        <div className="kards__card kards__card-forbidden">
          <h2 className="forbidden__title">
            گذاشتن اقلام زیر در تمام انواع مرسولات پستی ممنوع می باشد:‌
          </h2>
          <h3 className="forbidden__label">
            مواد مخدر و روان‌گردان بنا به تعریف هیأت بین‌المللی کنترل مواد مخدر،
            یا سایر داروهای غیرمجاز که در کشور مقصد ممنوع می باشند.
          </h3>
          <h3 className="forbidden__label">
            اقلام غیراخلاقی یا منافی عفت ( روزنامه، کارت، CD و نوار ویدئویی،
            مجله )
          </h3>
          <h3 className="forbidden__label">اقلام سرقتی و جعلی</h3>
          <h3 className="forbidden__label">
            اقلامی که داد و ستد و یا واردات آن ها در کشور مقصد ممنوع می باشد.
          </h3>
          <h3 className="forbidden__label">
            اقلامی که می‏ توانند مأموران یا عامه مردم را به لحاظ بسته بندی
            یاماهیت مرسوله در معرض خطر قرار دهند یا سبب خرابی یا آلوده شدن سایر
            بسته ها، تجهیزات پستی یا دارایی اشخاص شوند.
          </h3>
          <h3 className="forbidden__label">
            اسناد دارای جنبه مکاتبات شخصی و جاری که بین اشخاصی به جز گیرنده و
            فرستنده بسته یا افرادی که با آنها زندگی می‌کنند، مبادله شود.
          </h3>
          <h3 className="forbidden__label">
            مرسولات حاوی مواد منفجره، قابل اشتعال یا رادیو اکتیو و سایر کالای
            خطرناک (البته برخی از کالاهای خطرناک از جمله مواد رادیواکتیو ارسالی
            در پست‌نامه‌ها و باتری‌های لیتیومی و پیل ها ممنوع نمی باشند
          </h3>
          <h3 className="forbidden__label">
            مرسولات حاوی وسایل انفجاری و مهمات نظامی اصلی و مشقی مانند نارنجک و
            گلوله و سایر مهمات
          </h3>
          <h3 className="forbidden__label">حیوانات زنده</h3>

          <p className="forbidden__text">
            گذاشتن حیوانات زنده در تمام انواع مرسولات بجز موارد زیر در پست نامه
            ها جزء ممنوعات پستی می باشد.
          </p>

          <p className="forbidden__text">
            کرم ابریشم، زالو و زنبور، انگل‌ها و اقلام دافع حشرات موذی به منظور
            کنترل این حشرات که بین مؤسسات رسمی معتبر مبادله می ‏شوند.
          </p>

          <p className="forbidden__text">
            مگس‌های خانواده "دراسوفیلید" به منظور تحقیقات زیستی پزشکی که بین
            موسسات رسمی معتبر مبادله می‏ شوند.
          </p>

          <p className="forbidden__text">
            همچنین حیوانات زنده‌ای که حمل آنها توسط پست طبق مقررات پستی کشورهای
            ذیربط مجاز باشد.
          </p>

          <p className="forbidden__text">قراردادن مکاتبات در امانات</p>
        </div>
        <div className="kards__card kards__card-forbidden">
          <h2 className="forbidden__title">
            گذاشتن موارد زیر در امانات پستی ممنوع می باشد:‌
          </h2>
          <h3 className="forbidden__label">
            مکاتبات دارای جنبه شخصی، در داخل مرسولات با نرخ مخفف ( بسته‌های
            کوچک،امانات، مرسولات نابینایان، مطبوعات و ...)
          </h3>
          <h3 className="forbidden__label">
            مکاتبات به استثنای اسناد بایگانی، که میان اشخاصی به جز فرستنده و
            گیرنده مرسوله یا افرادی که با آنها زندگی می‌کنند، مبادله شود.
          </h3>
          <h3 className="forbidden__label">
            اوراق چاپی (مطبوعات) و مرسولات برای نابینایان
          </h3>
          <p className="forbidden__text">
            اوراق چاپی (مطبوعات) و مرسولات برای نابینایان نباید حاوی هیچ گونه
            یادداشت یا هر نوع مکاتبه‌ای، هیچ تمبر پستی یا هرگونه پیش پرداخت،
            باطل شده یا باطل نشده، یا هیچ ورقه بهادار معرف ارزش پولی باشند، بجز
            مواردی که مرسوله حاوی کارت، پاکت یا لفافی دارای نشانی خوانای فرستنده
            یا نماینده وی در کشور مبداء یا مقصد مرسوله اصلی باشد که هزینه برگشت
            آن از پیش پرداخت شده است باشد.
          </p>
          <h3 className="forbidden__label">سکه، اسکناس و سایر اقلام با ارزش</h3>
          <p className="forbidden__text">
            قراردادن سکه، اسکناس، هر نوع حواله بانکی یا اوراق بهادار بی‏نام، چک
            مسافرتی و پلاتین، طلا یا نقره(ساخته شده یا ساخته نشده) سنگ‌های
            قیمتی، جواهرات یا سایر اقلام با ارزش در موارد زیر جزء ممنوعات پستی
            میباشد :
          </p>
          <p className="forbidden__text">در مرسولات پست‌نامه غیر بیمه.</p>
          <p className="forbidden__text">
            <span className="forbidden__exception">تبصره :</span> در صورتی که
            قوانین ملی کشورهای مبداء و مقصد اجازه دهد، اشیاء مذکور را می‌توان در
            یک پاکت سربسته به عنوان مرسولات ثبتی ارسال کرد.
          </p>
          <p className="forbidden__text">
            در امانات غیر بیمه، به جز مواردی که در قوانین ملی کشورهای مبداء و
            مقصد مجاز شناخته شده است.
          </p>
          <p className="forbidden__text">
            در امانات غیر بیمه مبادله شده بین دو کشوری که امانات بیمه را می
            پذیرند.
          </p>
          <p className="forbidden__text">
            <span className="forbidden__exception">تبصره :</span> هر کشور عضو یا
            مجری منتخب می‌تواند گذاردن شمش طلا در امانات بیمه یا غیربیمه، از
            مبداء یا به مقصد قلمرو خود یا به صورت ترانزیت مکشوفه از قلمرو خود را
            ممنوع سازد و همچنین می‌تواند سقف ارزشی برای این مرسولات تعیین کند.
          </p>
        </div>
        <div className="kards__card kards__card-forbidden">
          <h2 className="forbidden__title">
            رفتار با مرسولات اشتباهی قبول شده:
          </h2>
          <p className="forbidden__text">
            به طور کلی نحوه رفتار با مرسولاتی که به اشتباه قبول شده‌اند در
            آیین‌نامه‌ها مشخص شده است. اما مرسولاتی همچون اقلام غیراخلاقی یا
            منافی عفت، مواد مخدر و روان‌گردان،مهمات نظامی اصلی و مشقی ،مواد
            منفجره، قابل اشتعال یا سایر کالای خطرناک و وسایل انفجاری در هیچ
            شرایطی نه به مقصد ارسال می شوند، نه به گیرندگان تحویل داده می‌شود و
            نه اینکه به مبدأ برگشت می خورد. همچنین اگر این اقلام در حالت ترانزیت
            کشف شوند، با چنین مرسولاتی طبق قوانین ملی کشور ترانزیت‌ کننده رفتار
            خواهد شد
          </p>
        </div>
      </div>
      <Link
        to="/order"
        className="main__Send-package"
      >
        <img className="main__Send-package-img" src="/img/postfix.png" alt="" />
        <h4>ارسال بسته</h4>
      </Link>
    </main>
  );
};

export default Forbidden;
